<template>
  <el-card>
    <template #header>
      <h4>{{ $t('会员中心') }}</h4>
    </template>

    <el-row>
      <el-col v-for="(item, index) in rowData" :key="index" :span="4">
        <div class="item">
          <span>{{ $t(item.name) }}</span>
          <span class="count">{{ data[item.key] || 0}}</span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: "MemberStat",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: [
        {name: '今日充值会员金额', count: 100, key: "todayVipPrice"},
        {name: '总充值会员金额', count: 100, key: "totalVipPrice"},
        {name: '今日兑换码会员激活数量', count: 100, key: "todayActivateCodeCount"},
        {name: '总兑换码会员激活数量', count: 100, key: "totalActivateCodeCount"},
      ]
    }
  }
}
</script>

<style scoped>

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
}

.count {
  font-weight: 600;
  font-size: 20px;
}

</style>
